__turbopack_context__.v({
  "expander": "ZcePjG_expander",
  "storyHighlightPulse": "ZcePjG_storyHighlightPulse",
  "storyHighlighted": "ZcePjG_storyHighlighted",
  "storyRow": "ZcePjG_storyRow",
  "summary": "ZcePjG_summary",
});
